package nl.staartvin.solarpower.data.uv

/**
 * Sunscreen protection levels the user can plan with.
 *
 * [factor] is the multiplier applied to time-to-burn: SPF n theoretically
 * lets skin tolerate n× the UV dose before reddening. This is the *ideal*
 * lab figure — real-world protection is lower because people apply less
 * than the test thickness and miss spots. The UI surfaces that caveat.
 *
 * [None] (factor 1.0) is the app's baseline: bare skin, the whole premise
 * of "how long can I skip sunscreen."
 */
enum class SpfLevel(val factor: Double, val label: String) {
    None(1.0, "No SPF"),
    Spf15(15.0, "SPF 15"),
    Spf30(30.0, "SPF 30"),
    Spf50(50.0, "SPF 50"),
    ;

    val isNone: Boolean get() = this == None

    companion object {
        val Default = None

        /** All cases as a List — used from Swift, where `entries` doesn't bridge cleanly. */
        val all: List<SpfLevel> = listOf(None, Spf15, Spf30, Spf50)

        /** Maps a stored factor back to a level, tolerating float rounding. */
        fun fromFactor(factor: Double): SpfLevel =
            all.minByOrNull { kotlin.math.abs(it.factor - factor) } ?: Default
    }
}
